// Components==============
import React from 'react';
import './City.module.scss';
// =========================

type Props = {
    children: React.ReactNode;
};

export default function City({ children }: Props) {
    return (
        <div styleName="city">
            {children}
            <img
                styleName="p-center"
                alt="grass"
                src="/images/background-assets/city/center.svg"
            />
            <img
                styleName="p-top-left"
                alt="grass"
                src="/images/background-assets/city/top-left.svg"
            />
            <img
                styleName="p-bottom-left"
                alt="grass"
                src="/images/background-assets/city/bottom-left.svg"
            />
            <img
                styleName="po-bottom-right"
                alt="grass"
                src="/images/background-assets/city/bottom-right.svg"
            />
        </div>
    );
}
